import { useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "../supabaseClient";
import * as usersService from "../services/usersService";

export function useUsersQuery() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel("users-changes")
      .on("postgres_changes", { event: "*", schema: "public", table: "users" }, () => {
        queryClient.invalidateQueries({ queryKey: ["users"] });
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, [queryClient]);

  return useQuery({
    queryKey: ["users"],
    queryFn: usersService.listUsers,
  });
}

export function useDisplayNameQuery(userId) {
  return useQuery({
    queryKey: ["users", "displayName", userId],
    queryFn: () => usersService.getDisplayName(userId),
    enabled: !!userId,
  });
}

export function useUpdateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersService.updateRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

export function useRenameUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersService.renameUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersService.deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

export function useSortOrder(userId) {
  return useQuery({
    queryKey: ["claimedItemsSort", userId],
    queryFn: () => usersService.getSortOrder(userId),
    enabled: !!userId,
  });
}

export function useSetSortOrder(userId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: usersService.setSortOrder,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["claimedItemsSort", userId] }),
  });
}
